import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { AuthService } from "../../shared/auth/auth.service";
import { Observable } from "rxjs/Observable";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.auth.getToken() || this.auth.getStaffToken() !== null) {
      request = request.clone({
        setHeaders: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${
            this.auth.getToken()
              ? this.auth.getToken()
              : this.auth.getStaffToken()
          }`,
        },
      });
    } else {
      request = request.clone({
        setHeaders: {
          "Content-Type": "application/json",
        },
      });
    }

    return next.handle(request);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/interceptors/token.interceptor.ts